// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3LhnR","inputWrap":"Table_inputWrap__1gX3n","col":"Table_col__JWN3G","bmiTooltip":"Table_bmiTooltip__17Ix9"};